import { LabelInternationalizationType } from 'src/Components/FeatureComponents/Response/Model';

export const LabelInternationalization: LabelInternationalizationType = {
	noLabel: {
		en: 'No',

		hi: 'नहीं',

		de: 'Nein',

		es: 'No',

		'zh-Hans': '没有',

		kn: 'ಇಲ್ಲ',

		ar: 'لا',

		id: 'Tidak',

		ta: 'இல்லை',

		pt: 'não',

		jp: '番号',

		ms: 'Tidak',
	},

	yesLabel: {
		en: 'Yes',

		hi: 'हाँ',

		de: 'Ja',

		es: 'Si',

		'zh-Hans': '是',

		kn: 'ಹೌದು',

		ar: 'نعم',

		ta: 'ஆம்',

		pt: 'sim',

		id: 'Iya',

		jp: 'はい',

		ms: 'ya',
	},

	branding: {
		en: 'Powered by <a href="http://www.flyfish.ai" target="_blank">Flyfish.ai</a>',

		hi: '<a href="http://www.flyfish.ai" target="_blank">Flyfish.ai</a> द्वारा संचालित',

		de: 'Unterstützt von <a href="http://www.flyfish.ai" target="_blank">Flyfish.ai</a>',

		es: 'Desarrollado por <a href="http://www.flyfish.ai" target="_blank">Flyfish.ai</a>',

		'zh-Hans':
			'由<a href="http://www.flyfish.ai" target="_blank">Flyfish.ai</a>提供支持',

		kn: '<a href="http://www.flyfish.ai" target="_blank">Flyfish.ai</a> ಅವರಿಂದ',

		ar: 'بواسطة <a href="http://www.flyfish.ai" target="_blank">Flyfish.ai</a>',

		id: 'Didukung oleh <a href="http://www.flyfish.ai" target="_blank">Flyfish.ai</a>',

		ta: ' <a href="http://www.flyfish.ai" target="_blank">Flyfish.ai</a> மூலம் இயக்கப்படுகிறது',

		pt: 'Distribuído por <a href="http://www.flyfish.ai" target="_blank">Flyfish.ai</a>',

		jp: '搭載 <a href="http://www.flyfish.ai" target="_blank">Flyfish.ai</a>',
		ms: 'Dikuasakan oleh <a href="http://www.flyfish.ai" target="_blank">Flyfish.ai</a> ',
	},

	sendLabel: {
		en: 'Send',

		hi: 'भेजें',

		de: 'Senden',

		es: 'Enviar',

		'zh-Hans': '发送',

		kn: 'ಕಳುಹಿಸು',

		ar: 'إرسال',

		id: 'Kirim',

		ta: 'அனுப்பு',

		pt: 'mandar',

		jp: '送信',

		ms: 'Hantar',
	},

	pollsLabel: {
		en: 'Polls',

		hi: 'मतदान',

		de: 'Umfragen',

		es: 'Centro',

		'zh-Hans': '民意调查',

		kn: 'ಸಮೀಕ್ಷೆಗಳು',

		ar: 'استطلاعات',

		id: 'pilihan',

		ta: 'கருத்துக்கணிப்புகள்',

		pt: 'Enquetes',

		jp: '世論調査',

		ms: 'Undian',
	},

	backToChat: {
		en: 'Back to Chat',

		hi: 'वापस चैट पर जाएँ',

		de: 'Zurück zum Chat',

		es: 'Volver al chat',

		'zh-Hans': '返回聊天',

		kn: 'ಚಾಟ್‌ಗೆ ಹಿಂತಿರುಗಿ',

		ar: 'العودة إلى الدردشة',

		id: 'Kembali ke Obrolan',

		ta: 'உரையாடலுக்கு திரும்பு',

		pt: 'Voltar ao bate-papo',

		jp: 'チャットに戻る',

		ms: 'Kembali ke Sembang',
	},

	helloLabel: {
		en: 'Hello',

		hi: 'नमस्ते',

		de: 'Hallo',

		es: 'Hola',

		'zh-Hans': '你好',

		kn: 'ಹಲೋ',

		ar: 'السلام عليكم',

		id: 'Salam',

		ta: 'வணக்கம்',

		pt: 'Olá',

		jp: 'こんにちは',

		ms: 'Hello',
	},

	submitLabel: {
		en: 'Submit',

		hi: 'दर्ज करें',

		de: 'einreichen',

		es: 'Enviar',

		'zh-Hans': '提交',

		kn: 'ಸಲ್ಲಿಸು',

		ar: 'إرسال',

		id: 'Kirimkan',

		ta: 'சமர்ப்பிக்க',

		pt: 'Enviar',

		jp: '参加する',

		ms: 'Hantar',
	},

	cancelLabel: {
		en: 'Cancel',

		hi: 'रद्द करें',

		de: 'Stornieren',

		es: 'Cancelar',

		'zh-Hans': '取消',

		kn: 'ರದ್ದುಮಾಡಿ',

		ar: 'إلغاء',

		id: 'Membatalkan',

		ta: 'ரத்து செய்',

		pt: 'Cancelar',

		jp: 'キャンセル',

		ms: 'Batal',
	},

	surveysLabel: {
		en: 'Surveys',

		hi: 'सर्वे',

		de: 'Umfragen',

		es: 'Encuestas',

		'zh-Hans': '调查',

		kn: 'ಸಮೀಕ್ಷೆಗಳು',

		ar: 'الدراسات الاستقصائية',

		id: 'Survei',

		ta: 'ஆய்வுகள்',

		pt: 'pesquisas',

		jp: '調査',

		ms: 'Tinjauan',
	},

	confirmLabel: {
		en: 'Confirm',

		hi: 'पुष्टि करें',

		de: 'Bestätigen',

		es: 'Confirmar',

		'zh-Hans': '确认',

		kn: 'ಖಚಿತಪಡಿಸಿ',

		ar: 'تؤكد',

		id: 'Konfirmasi',

		ta: 'உறுதிப்படுத்தவும்',

		pt: 'confirme',

		jp: '確認',

		ms: 'sahkan',
	},

	summaryLabel: {
		en: 'Summary',

		hi: 'सारांश',

		de: 'Zusammenfassung',

		es: 'Resumen',

		'zh-Hans': '摘要',

		kn: 'ಸಾರಾಂಶ',

		ar: 'ملخص',

		id: 'Ringkasan',

		ta: 'சுருக்கம்',

		pt: 'Resumo',

		jp: '概要',

		ms: 'Ringkasan',
	},

	feedbackLabel: {
		en: 'Give feedback',

		hi: 'फीडबैक दें',

		de: 'War ich hilfreich ?',

		es: '¿Fui útil?',

		'zh-Hans': '我有帮助吗',

		kn: 'ಪ್ರತಿಕ್ರಿಯೆ ಕೊಡಿ',

		ar: 'هل استفدت؟',

		id: 'Apakah saya membantu?',

		ta: 'கருத்து தெரிவிக்கவும்',

		pt: 'Dê retorno',

		jp: '役に立ちましたか',

		ms: 'Beri maklum balas',
	},

	quickLinksLabel: {
		en: 'Here are some quick links',

		hi: 'ये रहे कुछ उपयोगी लिंक ',

		de: 'Hier sind einige schnelle Links',

		es: 'Aquí hay algunos enlaces rápidos',

		'zh-Hans': '这里有一些快速链接',

		kn: 'ಕೆಲವು ತ್ವರಿತ ಲಿಂಕ್‌ಗಳು ಇಲ್ಲಿವೆ',

		ar: 'هنا بعض الروابط السريعة',

		id: 'Berikut ini beberapa tautan cepat',

		ta: 'இங்கே சில விரைவான இணைப்புகள் உள்ளன',

		pt: 'Aqui estão alguns links rápidos',

		jp: 'ここにいくつかのクイックリンクがあります',

		ms: 'Berikut adalah beberapa pautan pantas',
	},

	inputPlaceholder: {
		en: 'Type in a message',

		hi: 'कुछ लिखें',

		de: 'Eine Konversation beginnen',

		es: 'Iniciar una conversación',

		'zh-Hans': '开始对话',

		kn: 'ಸಂವಾದವನ್ನು ಪ್ರಾರಂಭಿಸಿ',

		ar: 'بدء محادثة',

		id: 'Mulai percakapan',

		ta: 'உங்கள் பதிலை உள்ளிடவும்',

		pt: 'Digite sua resposta',

		jp: '会話を始める',

		ms: 'Taip sesuatu',
	},

	exitConfirmation: {
		en: 'Please confirm that you wish to exit. Your chat will be cleared.',

		hi: 'कृपया पुष्टि करें कि आप चैट से बाहर निकलना चाहते हैं। आपकी अभी तक की चैट मिटा दी जाएगी।',

		de: 'Beim Beenden wird der gesamte Chat-Verlauf gelöscht',

		es: 'Al salir, se borrará todo el historial de chat',

		'zh-Hans': '退出时，所有聊天记录将被清除',

		kn: 'ನಿರ್ಗಮಿಸಿದಾಗ, ಎಲ್ಲಾ ಚಾಟ್ ಇತಿಹಾಸವನ್ನು ತೆರವುಗೊಳಿಸಲಾಗುತ್ತದೆ',

		ar: 'عند الخروج ، سيتم مسح كل سجل الدردشة',

		id: 'Saat keluar, semua riwayat obrolan akan dihapus',

		ta: 'நீங்கள் வெளியேற விரும்புகிறீர்கள் என்பதை உறுதிப்படுத்தவும். உங்கள் உரையாடல் அழிக்கப்படும்',

		pt: 'Por favor, confirme que você deseja sair. Seu chat será apagado.',

		jp: '終了時, すべてのチャット履歴がクリアされます',

		ms: 'Sila sahkan bahawa anda ingin keluar. Sembang anda akan dikosongkan.',
	},

	notificationsLabel: {
		en: 'Notifications',

		hi: 'सूचनाएँ',

		de: 'Benachrichtigungen',

		es: 'Notificaciones',

		'zh-Hans': '通知事项',

		kn: 'ಅಧಿಸೂಚನೆಗಳು',

		ar: 'إشعارات',

		id: 'Notifikasi',

		ta: 'அறிவிப்புகள்',

		pt: 'Notificações',

		jp: '通知',

		ms: 'Pemberitahuan',
	},

	selectLanguageLabel: {
		en: 'Select language',

		hi: 'भाषा चुनें',

		de: 'Sprache auswählen',

		es: 'Seleccione el idioma',

		'zh-Hans': '选择语言',

		kn: 'ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ',

		ar: 'اختار اللغة',

		id: 'Pilih bahasa',

		ta: 'மொழியை தேர்ந்தெடுங்கள்',

		pt: 'Selecione o idioma',

		jp: '選択する 言語',

		ms: 'Pilih Bahasa',
	},

	feedbackPlaceholder: {
		en: 'Type your comments here',

		hi: 'अपनी टिप्पणी यहां लिखें',

		de: 'Geben Sie hier Ihre Kommentare ein',

		es: 'Escriba sus comentarios aquí',

		'zh-Hans': '在这里输入您的评论',

		kn: 'ನಿಮ್ಮ ಕಾಮೆಂಟ್‌ಗಳನ್ನು ಇಲ್ಲಿ ಟೈಪ್ ಮಾಡಿ',

		ar: 'اكتب تعليقاتك هنا',

		id: 'Ketikkan komentar Anda di sini',

		jp: 'ここにコメントを入力してください',

		ta: 'உங்கள் கருத்துக்களை இங்கே தட்டச்சு செய்யவும்',

		pt: 'Digite seus comentários aqui',

		ms: 'Taip komen anda di sini',
	},

	feedbackConfirmation: {
		en: 'Thank you for submitting your feedback',

		hi: 'फ़ीडबैक देने के लिए आपका धन्यवाद',

		de: 'Vielen Dank für Ihr Feedback',

		es: 'Gracias por enviar sus comentarios.',

		'zh-Hans': '感谢您提交您的反馈',

		kn: 'ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆಯನ್ನು ಸಲ್ಲಿಸಿದ್ದಕ್ಕಾಗಿ ಧನ್ಯವಾದಗಳು',

		ar: 'شكرا لك على تقديم تعليقاتك',

		id: 'Terima kasih telah mengirimkan umpan balik Anda',

		ta: 'உங்கள் கருத்தைச் சமர்ப்பித்ததற்கு நன்றி',

		pt: 'Obrigado por enviar seus comentários',

		jp: 'フィードバックを送信していただきありがとうございます',

		ms: 'Terima kasih kerana menghantar maklum balas anda',
	},

	langConfirmationLabel: {
		en: 'Change language?<br/>Your chat till now will be cleared.',

		hi: 'भाषा बदलें?<br />आपकी अभी तक की बातचीत मिटा दी जाएगी।',

		de: 'Sprache ändern? <br/> Ihre bisherigen Chats werden gelöscht.',

		es: '¿Cambiar idioma? <br/> Tus chats hasta ahora serán eliminados.',

		'zh-Hans': '改变语言？ <br/>到目前为止，您的聊天记录将被删除。',

		kn: 'ಭಾಷೆಯನ್ನು ಬದಲಾಯಿಸುವುದೇ? <br/> ಇಲ್ಲಿಯವರೆಗೆ ನಿಮ್ಮ ಚಾಟ್ ಅನ್ನು ತೆರವುಗೊಳಿಸಲಾಗುತ್ತದೆ.',

		ar: 'تغيير اللغة؟ <br/> سيتم مسح الدردشة الخاصة بك حتى الآن.',

		id: 'Ubah bahasa? <br/> Obrolan Anda sampai sekarang akan dihapus.',

		ta: 'மொழியை மாற்றவா?<br/>இதுவரை உங்கள் உரையாடல் அழிக்கப்படும்',

		pt: 'Mudar idioma?<br/>Seu bate-papo até agora será apagado.',

		jp: '変化する 言語?<br/> これまでのチャットはクリアされます',

		ms: 'Tukar bahasa?<br/>Sembang anda sehingga sekarang akan dikosongkan.',
	},

	languageChange: {
		en: 'Change language',

		hi: 'भाषा बदलें',

		de: 'Sprache ändern.',

		es: '¿Cambiar idioma.',

		'zh-Hans': '改变语言',

		kn: 'ಭಾಷೆಯನ್ನು ಬದಲಾಯಿಸಿ',

		ar: 'تغيير اللغ؟ .',

		id: 'Ubah bahasa.',

		ta: 'மொழியை மாற்று',

		pt: 'Mudar idioma.',

		jp: '変化する 言語',

		ms: 'Tukar bahasa',
	},

	startNewChatLabel: {
		en: 'Start new chat',

		ar: 'ابدأ محادثة جديدة',

		'zh-Hans': '开始新的聊天',

		de: 'Neuen Chat starten',

		hi: 'नई चैट शुरू करें',

		id: 'Mulai obrolan baru',

		kn: 'ಹೊಸ ಚಾಟ್ ಪ್ರಾರಂಭಿಸಿ',

		pt: 'Iniciar novo bate-papo',

		es: 'Iniciar un nuevo chat',

		ta: 'புதிய உரையாடலைத் தொடங்கவும்',

		jp: '新しいチャットを開始する',

		ms: 'Mulakan sembang baharu',
	},

	continueLabel: {
		en: 'Continue',

		ar: 'استمر',

		'zh-Hans': '继续',

		de: 'fortsetzen',

		hi: 'आगे बढ़ें',

		id: 'melanjutkan',

		kn: 'ಮುಂದುವರಿಸಿ',

		pt: 'Prosseguir',

		es: 'Seguir',

		ta: 'தொடரவும்',

		jp: '継続する',

		ms: 'Teruskan',
	},

	continueChatLabel: {
		en: 'Continue chat',

		ar: 'تواصل الدردشة',

		'zh-Hans': '继续聊天',

		de: 'Chat fortsetzen',

		hi: 'चैट जारी रखें',

		id: 'Lanjutkan obrolan',

		kn: 'ಚಾಟ್ ಮುಂದುವರಿಸಿ',

		pt: 'Continue chat',

		es: 'Continuar chat',

		ta: 'உரையாடலைத் தொடரவும்',

		jp: 'チャットを続ける',

		ms: 'Teruskan sembang',
	},

	exitChatLabel: {
		en: 'Exit chat',

		ar: 'الخروج من الدردشة',

		'zh-Hans': '退出聊天',

		de: 'Chat beenden',

		hi: 'चैट से बाहर निकलें',

		id: 'Keluar dari obrolan',

		kn: 'ಚಾಟ್‌ನಿಂದ ನಿರ್ಗಮಿಸಿ',

		pt: 'Sair do chat',

		es: 'Salir del chat',

		ta: 'உரையாடலில் இருந்து வெளியேறு',

		jp: 'チャットを終了する',

		ms: 'Keluar sembang',
	},

	chatExperience: {
		en: 'How was your chat experience?',

		ar: 'كيف كانت تجربة الدردشة الخاصة بك؟',

		'zh-Hans': '你的聊天体验如何?',

		de: 'Wie war Ihr Chat-Erlebnis?',

		hi: 'आपका चैट करने का अनुभव कैसा रहा?',

		id: 'Bagaimana pengalaman obrolan Anda?',

		kn: 'ನಿಮ್ಮ ಚಾಟ್ ಅನುಭವ ಹೇಗಿತ್ತು?',

		pt: 'Como foi sua experiência de chat?',

		es: '¿Cómo fue tu experiencia en el chat?',

		ta: 'உங்கள் உரையாடல் அனுபவம் எப்படி இருந்தது?',

		jp: 'チャット体験はいかがでしたか？',

		ms: 'Bagaimanakah pengalaman sembang anda?',
	},

	chatExit: {
		en: 'Exit chat?',

		ar: 'هل تريد الخروج من الدردشة؟',

		'zh-Hans': '退出聊天？',

		de: 'Chat beenden?',

		hi: 'चैट से बाहर निकलें?',

		id: 'Keluar dari Obrolan?',

		kn: 'ಚಾಟ್‌ನಿಂದ ನಿರ್ಗಮಿಸಿ',

		pt: 'Sair do bate-papo?',

		es: '¿Salir del chat?',

		ta: 'உரையாடலில் இருந்து வெளியேறவா?',

		jp: 'チャットを終了しますか？',

		ms: 'Keluar sembang?',
	},

	exitComponent: {
		en: 'Exit',

		ar: 'مخرج',

		'zh-Hans': '出口',

		de: 'Ausgang',

		hi: 'बाहर जाएँ',

		id: 'keluar',

		kn: 'ನಿರ್ಗಮಿಸಿ',

		pt: 'Saída',

		es: 'Salida',

		ta: 'வெளியேறு',

		jp: '出口',

		ms: 'Keluar',
	},

	addComment: {
		en: 'Give additional feedback',

		ar: 'أضف تعليق (اختياري)',

		'zh-Hans': '添加评论（可选）',

		de: 'Kommentar hinzufügen (optional)',

		hi: 'विवरण दें (ऐच्छिक)',

		id: 'Tambahkan komentar (opsional)',

		kn: 'ಕಾಮೆಂಟ್ ಸೇರಿಸಿ (ಐಚ್ಛಿಕ)',

		pt: 'Adicione um comentário (opcional)',

		es: 'Agregar un comentario (opcional)',

		ta: 'கருத்தைச் சேர்க்கவும் (விரும்பினால்)',

		jp: 'コメントを追加（オプション）',

		ms: 'Tambahkan ulasan (pilihan)',
	},

	skipLabel: {
		en: 'Skip',

		ar: 'يتخطى',

		'zh-Hans': '跳过',

		de: 'Überspringen',

		hi: 'छोड़ें',

		id: 'Melewati',

		kn: 'ಬಿಟ್ಟುಬಿಡಿ',

		pt: 'Pular',

		es: 'Saltar',

		ta: 'தவிர்க்கவும்',

		jp: 'スキップ',

		ms: 'Langkau',
	},

	tellUsMoreLabel: {
		en: 'Please tell us more',

		ar: 'إخبرنا المزيد',

		'zh-Hans': '跟我们多说些',

		de: 'Erzählen Sie uns mehr',

		hi: 'विवरण दें',

		id: 'Beritahu kami lebih lanjut',

		kn: 'ನಮಗೆ ಇನ್ನಷ್ಟು ಹೇಳಿ',

		pt: 'conte-nos mais',

		es: 'Cuéntanos más',

		ta: 'மேலும் சொல்லுங்கள்',

		jp: 'もっと教えて',

		ms: 'Beritahu kami lebih lanjut',
	},

	dismissLabel: {
		en: 'Dismiss',

		ar: 'رفض',

		'zh-Hans': '解雇',

		de: 'Zurückweisen',

		hi: 'खारिज करें',

		id: 'Memberhentikan',

		kn: 'ವಜಾಗೊಳಿಸಿ',

		pt: 'Liberar',

		es: 'Despedir',

		ta: 'நிராகரி',

		jp: '退出させる',

		ms: 'Tolak',
	},

	dontShowLabel: {
		en: "Don't show again",

		ar: 'لا تظهر مرة أخرى',

		'zh-Hans': '不再显示',

		de: 'Nicht mehr anzeigen',

		hi: 'दोबारा ना दिखाएँ',

		id: 'Jangan tampilkan lagi',

		kn: 'ಮತ್ತೆ ತೋರಿಸಬೇಡ',

		pt: 'Não mostra de novo',

		es: 'No volver a mostrar',

		ta: 'மீண்டும் காட்டாதே',

		jp: '二度と表示しない',

		ms: 'Jangan tunjukkan lagi',
	},

	noNotificationLabel: {
		en: 'No notifications',

		ar: 'لا إشعارات',

		'zh-Hans': '没有通知',

		de: 'Keine Benachrichtigungen',

		hi: 'कोई सूचनाएं नहीं',

		id: 'Tidak ada pemberitahuan',

		kn: 'ಯಾವುದೇ ಅಧಿಸೂಚನೆಗಳಿಲ್ಲ',

		pt: 'Nenhuma notificação',

		es: 'No Notificaciones',

		ta: 'அறிவிப்புகள் இல்லை',

		jp: '通知なし',

		ms: 'Tiada pemberitahuan',
	},

	shareLabel: {
		en: 'Share',

		ar: 'يشارك',

		'zh-Hans': '分享',

		de: 'Teilen',

		hi: 'टैस्टिंग के लिए लिंक',

		id: 'Membagikan',

		kn: 'ಹಂಚಿಕೊಳ್ಳಿ',

		pt: 'Compartilhado',

		es: 'Cuota',

		ta: 'பகிர்',

		jp: '共有',

		ms: 'Kongsi',
	},

	logoutLabel: {
		en: 'Logout',

		ar: 'تسجيل خروج',

		'zh-Hans': '登出',

		de: 'Ausloggen',

		hi: 'लॉग आउट करें',

		id: 'Keluar',

		kn: 'ಲಾಗ್ ಔಟ್',

		pt: 'Sair',

		es: 'Cerrar sesión',

		ta: 'வெளியேறு',

		jp: 'ログアウト',

		ms: 'Log keluar',
	},

	refreshLabel: {
		en: 'Refresh',

		ar: 'ينعش',

		'zh-Hans': '刷新',

		de: 'Aktualisierung',

		hi: 'रीफ़्रेश करें',

		id: 'Menyegarkan',

		kn: 'ರಿಫ್ರೆಶ್ ಮಾಡಿ',

		pt: 'Atualizar',

		es: 'Actualizar',

		ta: 'புதுப்பி',

		jp: '更新',

		ms: 'Segarkan semula',
	},

	maximiseLabel: {
		en: 'Maximise',

		ar: 'تحقيق أقصى قدر',

		'zh-Hans': '最大化',

		de: 'Maximieren',

		hi: 'बड़ा करें',

		id: 'Maksimalkan',

		kn: 'ವಿಸ್ತರಿಸಿ',

		pt: 'Maximizar',

		es: 'Maximizar',

		ta: 'அதிகப்படுத்து',

		jp: '最大化',

		ms: 'Maksimumkan',
	},

	minimiseLabel: {
		en: 'Minimise',

		ar: 'تصغير',

		'zh-Hans': '最大化',

		de: 'Minimieren',

		hi: 'छोटा करें',

		kn: 'ಕಡಿಮೆಗೊಳಿಸು',

		id: 'Memperkecil',

		pt: 'Minimizar',

		es: 'Minimizar',

		ta: 'குறைக்கவும்',

		jp: '最小化',

		ms: 'Minimumkan',
	},

	closeLabel: {
		en: 'Close',

		ar: 'قريب',

		'zh-Hans': '关闭',

		de: 'Nah dran',

		hi: 'बंद करें',

		id: 'Menutup',

		kn: 'ಮುಚ್ಚಿ',

		pt: 'Fechar',

		es: 'Cerrar',

		ta: 'மூடு',

		jp: '選ぶ',

		ms: 'tutup',
	},

	moreOptionsLabel: {
		en: 'More options',

		ar: 'المزيد من الخيارات',

		'zh-Hans': '更多选择',

		de: 'Mehr Optionen',

		hi: 'और दिखाएं',

		id: 'Lebih banyak pilihan',

		kn: 'ಹೆಚ್ಚಿನ ಆಯ್ಕೆಗಳು',

		pt: 'Mais opções',

		es: 'Mas opciones',

		ta: 'மேலும் விருப்பங்கள்',

		jp: 'より多くのオプション',

		ms: 'Lebih banyak pilihan',
	},
	loginLabel: {
		en: 'Login',

		ar: 'تسجيل الدخول',

		'zh-Hans': '登录',

		de: 'Anmeldung',

		hi: 'लॉग इन करें',

		id: 'Gabung',

		kn: 'ಲಾಗಿನ್',

		pt: 'Conecte-se',

		es: 'acceso',

		ta: 'உள்நுழைய',

		jp: 'ログインする',

		ms: 'Log masuk',
	},
	SelectLabel: {
		en: 'Select',

		ar: 'تحديد',

		'zh-Hans': '选择',

		de: 'wählen',

		hi: 'चुनें',

		id: 'Pilih',

		kn: 'ಆಯ್ಕೆ ಮಾಡಿ',

		pt: 'selecionar',

		es: 'Seleccione',

		ta: 'தேர்ந்தெடுக்கவும்',

		jp: '選択する',

		ms: 'Pilih',
	},
	SelectedLabel: {
		en: 'Selected',

		ar: 'المحدد',

		'zh-Hans': '被选中',

		de: 'ausgewählt',

		hi: 'चयनित',

		id: 'terpilih',

		kn: 'ಆಯ್ದ',

		pt: 'selecionado',

		es: 'seleccionado',

		ta: 'தேர்ந்தெடுக்கப்பட்டது',

		jp: '選択',

		ms: 'Dipilih',
	},
	VeryBadLabel: {
		en: 'Very Bad',

		ar: 'سيئ جدا',

		'zh-Hans': '很坏',

		de: 'Sehr schlecht',

		hi: 'बहुत ख़राब',

		id: 'Sangat buruk',

		kn: 'ತುಂಬಾ ಕೆಟ್ಟದ್ದು',

		pt: 'Muito mal',

		es: 'Muy malo',

		ta: 'மிகவும் மோசமானது',

		jp: 'ひどい',

		ms: 'Sangat teruk',
	},
	BadLabel: {
		en: 'Bad',

		ar: 'سيئة',

		'zh-Hans': '坏的',

		de: 'Schlecht',

		hi: 'ख़राब',

		id: 'Buruk',

		kn: 'ಕೆಟ್ಟ',

		pt: 'Ruim',

		es: 'Malo',

		ta: 'மோசமானது',

		jp: '悪い',

		ms: 'teruk',
	},
	OkayLabel: {
		en: 'Okay',

		ar: 'حسنا',

		'zh-Hans': '好的',

		de: 'Okay',

		hi: 'ठीक',

		id: 'Oke',

		kn: 'ಸರಿ',

		pt: 'OK',

		es: 'Bueno',

		ta: 'சரி',

		jp: 'わかった',

		ms: 'baik',
	},
	GoodLabel: {
		en: 'Good',

		ar: 'حسن',

		'zh-Hans': '好的',

		de: 'gut',

		hi: 'अच्छा',

		id: 'bagus',

		kn: 'ಒಳ್ಳೆಯದು',

		pt: 'bom',

		es: 'Bueno',

		ta: 'நல்லத',

		jp: '良い',

		ms: 'Baik',
	},
	ExcellentLabel: {
		en: 'Excellent!',

		ar: 'ممتاز',

		'zh-Hans': '优秀的',

		de: 'Ausgezeichnet',

		hi: 'बहुत अच्छा',

		id: 'Bagus sekali',

		kn: 'ಅತ್ಯುತ್ತಮ',

		pt: 'Excelente',

		es: 'Excelente',

		ta: 'சிறப்பானது',

		jp: '優れた',

		ms: 'Cemerlang!',
	},
	ThanksFeedbackLabel: {
		en: 'Thank you for your feedback',

		ar: 'شكرا لك على ملاحظاتك',

		'zh-Hans': '感谢您的反馈意见',

		de: 'Danke für Ihre Rückmeldung',

		hi: 'फ़ीडबैक के लिए आपका धन्यवाद',

		id: 'Terima kasih atas tanggapan Anda',

		kn: 'ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆಗಾಗಿ ಧನ್ಯವಾದಗಳು',

		pt: 'Obrigado pelo seu feedback',

		es: 'Gracias por tus comentarios',

		ta: 'உங்கள் கருத்துக்கு நன்றி',

		jp: 'ご意見ありがとうございます',

		ms: 'Terima kasih atas maklum balas anda',
	},
	ThanksResponse: {
		en: 'Thank you for your response',

		ar: 'شكرا لردكم',

		'zh-Hans': '感谢您的答复',

		de: 'danke für Ihre Antwort',

		hi: 'आपकी प्रतिक्रिया के लिए धन्यवाद',

		id: 'Terima kasih atas tanggapan Anda',

		kn: 'ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆಗಾಗಿ ಧನ್ಯವಾದಗಳು',

		pt: 'Obrigado pela sua resposta',

		es: 'Gracias por su respuesta',

		ta: 'உங்கள் பதிலுக்கு நன்றி',

		jp: 'ご回答ありがとうございます',

		ms: 'Terima kasih atas maklum balas anda',
	},
	EditLabel: {
		en: 'Edit',

		ar: 'تعديل',

		'zh-Hans': '编辑',

		de: 'Bearbeiten',

		hi: 'बदलें',

		id: 'Sunting',

		kn: 'ತಿದ್ದು',

		pt: 'Editar',

		es: 'Editar',

		ta: 'திருத்த',

		jp: '編集',

		ms: 'Sunting',
	},
	voiceLabel: {
		en: 'Mic',

		ar: 'ميكروفون',

		'zh-Hans': '麦克风',

		de: 'Mikrofon',

		hi: 'माइक',

		id: 'mikrofon',

		kn: 'ಮೈಕ್',

		pt: 'Microfone',

		es: 'Micrófono',

		ta: 'ஒலிவாங்கி',

		jp: 'マイク',

		ms: 'Mikrofon',
	},

	relatedQuestionsLabel: {
		en: 'Related Questions',

		ar: 'أسئلة ذات صلة',

		'zh-Hans': '相关问题',

		de: 'Verwandte Fragen',

		hi: 'संबंधित प्रश्न',

		id: 'Pertanyaan-pertanyaan Terkait',

		kn: 'ಸಂಬಂಧಿತ ಪ್ರಶ್ನೆಗಳು',

		pt: 'Perguntas relacionadas',

		es: 'preguntas relacionadas',

		ta: 'தொடர்புடைய கேள்விகள்',

		jp: '関連する質問',

		ms: 'Soalan Berkaitan',
	},
	copyIconLabel: {
		en: 'Copy Icon',
		hi: 'कॉपी आइकन',
		ar: 'ينسخ',
		'zh-Hans': '复制',
		de: 'Kopieren',
		kn: 'ನಕಲು ಮಾಡಿ',
		pt: 'cópia de',
		ms: 'Salinan',
		id: 'Salinan',
		ta: 'நகலெடுக்கவும்',
		es: 'Dupdo',
	},
	uploadFileLabel: {
		en: 'Upload File',
		hi: 'फाइल अपलोड',
		ar: 'تحميل الملف',
		'zh-Hans': '上传文件',
		de: 'Datei-Upload',
		kn: 'ಫೈಲ್ ಅಪ್‌ಲೋಡ್',
		pt: 'Upload de arquivo',
		ms: 'Fail dimuatnaik',
		id: 'Unggah File',
		ta: 'கோப்பு பதிவேற்றம்',
		es: 'Subir archivo',
	},
	warningIconLabel: {
		en: 'Warning icon',
		hi: 'चेतावनी आइकन',
		ar: ' رمز التحذير',
		'zh-Hans': '警告图标',
		de: 'Warnsymbol',
		kn: 'ಎಚ್ಚರಿಕೆ ಐಕಾನ್',
		pt: 'Ícone de aviso',
		ms: 'Ikon amaran',
		id: 'Ikon peringatan',
		ta: 'எச்சரிக்கை ஐகான்',
		es: 'Icono de advertencia',
	},
	privateBotLabel: {
		en: 'Private Bot',
		hi: 'निजी Bot',
		ar: ' بوت خاص',
		'zh-Hans': ' 私人机器人',
		de: 'Privater Bot',
		kn: 'ಖಾಸಗಿ ಬಾಟ್',
		pt: 'Bot privado',
		ms: 'Bot Persendirian',
		id: 'Bot Pribadi',
		ta: 'தனியார் பாட்',
		es: 'Robot privado',
	},
	fileUploadedSuccessfullyLabel: {
		en: 'File Uploaded Successfully',
		hi: 'फ़ाइल सफलतापूर्वक अपलोड की गई',
		ar: 'تم رفع الملف بنجاح',
		'zh-Hans': '文件上传成功',
		de: 'Datei erfolgreich hochgeladen',
		kn: 'ಫೈಲ್ ಅನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಅಪ್‌ಲೋಡ್ ಮಾಡಲಾಗಿದೆ',
		pt: 'Arquivo enviado com sucesso',
		ms: 'Fail Berjaya Dimuat Naik',
		id: 'Berkas berhasil diunggah',
		ta: 'கோப்பு வெற்றிகரமாக பதிவேற்றப்பட்டது',
		es: 'Documento cargado exitosamente',
	},

	expandIconLabel: {
		en: 'Expand Icon',
		hi: 'विस्तृत करें चिह्न',
		ar: 'توسيع الأيقونة',
		'zh-Hans': '展开图标',
		de: 'Symbol erweitern',
		kn: 'ವಿಸ್ತರಿಸಿ ಐಕಾನ್',
		pt: 'Expandir ícone',
		ms: 'Kembangkan Ikon',
		id: 'Perluas Ikon',
		ta: 'விரிவாக்க ஐகான்',
		es: 'Expandir icono',
	},
	redWarningIconLabel: {
		en: 'Red Warning Icon',

		hi: 'लाल चेतावनी चिह्न',

		ar: 'رمز التحذير الأحمر',

		'zh-Hans': '红色警告图标',

		de: 'Rotes Warnsymbol',

		kn: 'ಕೆಂಪು ಎಚ್ಚರಿಕೆ ಐಕಾನ್',

		pt: 'Ícone de aviso vermelho',

		ms: 'Ikon Amaran Merah',

		id: 'Ikon Peringatan Merah',

		ta: 'சிவப்பு எச்சரிக்கை ஐகான்',

		es: 'Icono de advertencia rojo',
	},
	backIconLabel: {
		en: 'Back Icon',

		hi: 'पिछला चिह्न',

		ar: 'رمز العودة',

		'zh-Hans': '返回图标',

		de: 'Zurück-Symbol',

		kn: 'ಹಿಂದೆ ಐಕಾನ್',

		pt: 'Ícone Voltar',

		ms: 'Ikon Belakang',

		id: 'Ikon Kembali',

		ta: 'பின் ஐகான்',

		es: 'Icono Atrás',
	},
	botAvatarLabel: {
		en: 'Bot Avatar',

		hi: 'बॉट अवतार',

		ar: 'بوت الصورة الرمزية',

		'zh-Hans': '机器人头像',

		de: 'Bot-Avatar',

		kn: 'ಬಾಟ್ ಅವತಾರ್',

		pt: 'Avatar de bot',

		ms: 'Bot Avatar',

		id: 'Bot Avatar',

		ta: 'பாட் அவதார்',

		es: 'Avatar de robot',
	},
	coverImageLabel: {
		en: 'cover image',

		hi: 'कवर छवि',

		ar: 'صورة الغلاف',

		'zh-Hans': '封面图片',

		de: 'Titelbild',

		kn: 'ಕವರ್ ಚಿತ್ರ',

		pt: 'imagem de capa',

		ms: 'gambar muka depan',

		id: 'gambar sampul',

		ta: 'அட்டைப் படம்',

		es: 'Imagen de portada',
	},
	welcomeScreenLabel: {
		en: 'Welcome Screen',

		hi: 'स्वागत स्क्रीन',

		ar: 'شاشة الترحيب',

		'zh-Hans': '欢迎屏幕',

		de: 'Begrüßungsbildschirm',

		kn: 'ಸ್ವಾಗತ ಪರದೆ',

		pt: 'Tela de boas vindas',

		ms: 'Skrin Selamat Datang',

		id: 'Layar Selamat Datang',

		ta: 'வரவேற்பு திரை',

		es: 'Pantalla de bienvenida',
	},
	botIconLabel: {
		en: 'Bot Icon',

		hi: 'बॉट चिह्न',

		ar: 'أيقونة بوت',

		'zh-Hans': '机器人图标',

		de: 'Bot-Symbol',

		kn: 'ಬಾಟ್ ಐಕಾನ್',

		pt: 'Ícone de bot',

		ms: 'Ikon Bot',

		id: 'Ikon Bot',

		ta: 'பாட் ஐகான்',

		es: 'Icono de robot',
	},
	shadowLabel: {
		en: 'Shadow',

		hi: 'साया',

		ar: 'ظل',

		'zh-Hans': '阴影',

		de: 'Schatten',

		kn: 'ನೆರಳು',

		pt: 'Sombra',

		ms: 'Bayang-bayang',

		id: 'Bayangan',

		ta: 'நிழல்',

		es: 'Sombra',
	},
	chatWindowOpenLabel: {
		en: 'Chat Window Open',

		hi: 'चैट विंडो ओपन',

		ar: 'نافذة الدردشة مفتوحة',

		'zh-Hans': '聊天窗口打开',

		de: 'Chatfenster geöffnet',

		kn: 'ಚಾಟ್ ವಿಂಡೋ ತೆರೆಯಿರಿ',

		pt: 'Janela de bate-papo aberta',

		ms: 'Tetingkap Sembang Dibuka',

		id: 'Jendela Obrolan Terbuka',

		ta: 'உரையாடல் சாளரம் திறக்கிறது',

		es: 'Ventana de chat abierta',
	},
	typeYourMessageLabel: {
		en: 'Type Your Message',

		hi: 'अपना संदेश टाइप करें',

		ar: 'اكتب رسالتك',

		'zh-Hans': '输入您的信息',

		de: 'Geben Sie Ihre Nachricht ein',

		kn: 'ನಿಮ್ಮ ಸಂದೇಶವನ್ನು ಟೈಪ್ ಮಾಡಿ',

		pt: 'Digite sua mensagem',

		ms: 'Taip Mesej Anda',

		id: 'Ketik pesan anda',

		ta: 'உங்கள் செய்தியைத் தட்டச்சு செய்யவும்',

		es: 'Escribe tu mensaje',
	},
	starSelectedLabel: {
		en: 'star selected',

		hi: 'स्टार चयनित',

		ar: 'تم تحديد نجمة',

		'zh-Hans': '已选星',

		de: 'Stern ausgewählt',

		kn: 'ನಕ್ಷತ್ರವನ್ನು ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ',

		pt: 'estrela selecionada',

		ms: 'bintang dipilih',

		id: 'bintang dipilih',

		ta: 'நட்சத்திரம் தேர்ந்தெடுக்கப்பட்டது',

		es: 'estrella seleccionada',
	},
	checkboxLabel: {
		en: 'checkbox',

		hi: 'चेक बॉक्स',

		ar: 'خانة الاختيار',

		'zh-Hans': '复选框',

		de: 'Kontrollkästchen',

		kn: 'ಚೆಕ್ಬಾಕ್ಸ್',

		pt: 'caixa de seleção',

		ms: 'kotak semak',

		id: 'kotak centang',

		ta: 'தேர்வுப்பெட்டி',

		es: 'caja',
	},
	unselectedLabel: {
		en: 'unselected',

		hi: 'अचयनित',

		ar: 'غير محدد',

		'zh-Hans': '未选中',

		de: 'nicht ausgewählt',

		kn: 'ಆಯ್ಕೆ ಮಾಡದ',

		pt: 'Não selecionado',

		ms: 'tidak dipilih',

		id: 'tidak dipilih',

		ta: 'தேர்ந்தெடுக்கப்படவில்லை',

		es: 'no seleccionado',
	},
	pleaseWaitForProcessingTocompleteToRefreshTheChatLabel: {
		en: 'Please wait for processing to complete to refresh the chat',

		hi: 'कृपया चैट को रीफ़्रेश करने के लिए प्रसंस्करण पूर्ण होने की प्रतीक्षा करें',

		ar: 'يرجى الانتظار حتى تكتمل المعالجة \\ n لتحديث الدردشة',

		'zh-Hans': '请等待处理完成以 刷新聊天',

		de: 'Bitte warten Sie, bis die Verarbeitung abgeschlossen ist, um den Chat zu aktualisieren',

		kn: 'ಚಾಟ್ ಅನ್ನು ರಿಫ್ರೆಶ್ ಮಾಡಲು ಪ್ರಕ್ರಿಯೆ ಪೂರ್ಣಗೊಳ್ಳುವವರೆಗೆ ದಯವಿಟ್ಟು ನಿರೀಕ್ಷಿಸಿ',

		pt: 'Aguarde o processamento completar para atualizar o bate-papo',

		ms: 'Sila tunggu pemprosesan hingga selesai untuk memuat semula sembang',

		id: 'Harap tunggu pemrosesan hingga selesai untuk menyegarkan obrolan',

		ta: 'உரையாடலைப் புதுப்பிக்க, செயலாக்கம் முடிவடையும் வரை காத்திருக்கவும்',

		es: 'Espere a que se complete el procesamiento para actualizar el chat.',
	},
	exitLabel: {
		en: 'Exit',

		hi: 'बाहर जाएं',

		ar: 'مخرج',

		'zh-Hans': '出口',

		de: 'Ausgang',

		kn: 'ನಿರ್ಗಮಿಸಿ',

		pt: 'Saída',

		ms: 'Keluar',

		id: 'keluar',

		ta: 'வெளியேறு',

		es: 'Salida',
	},

	disabledLabel: {
		en: 'disabled',

		hi: 'निष्क्रिय',

		ar: 'معاق',

		'zh-Hans': '禁用',

		de: 'behindert',

		kn: 'ನಿಷ್ಕ್ರಿಯ',

		pt: 'Desativado',

		ms: 'kurang upaya',

		id: 'dengan disabilitas',

		ta: 'முடக்கப்பட்டுள்ளது்',

		es: 'discapacitado',
	},
	enabledLabel: {
		en: 'enabled',

		hi: 'सक्षम',

		ar: 'ممكن',

		'zh-Hans': '启用',

		de: 'aktiviert',

		kn: 'ಸಕ್ರಿಯ',

		pt: 'ativado',

		ms: 'didayakan',

		id: 'diaktifkan',

		ta: 'செயல்படுத்தப்பட்டது',

		es: 'activado',
	},
	starLabel: {
		en: 'star',

		hi: 'सितारा',

		ar: 'نجمة',

		'zh-Hans': '星星',

		de: 'Stern',

		kn: 'ನಕ್ಷತ್ರ',

		pt: 'Estrela',

		ms: 'bintang',

		id: 'bintang',

		ta: 'நட்சத்திரம்',

		es: 'estrella',
	},
	thumbsUpLabel: {
		en: 'Thumbs up',

		hi: 'सही',

		ar: 'الصحيح',

		'zh-Hans': '正确',

		de: 'Recht',

		kn: 'ಸರಿ',

		pt: 'Certa',

		ms: 'Betul',

		id: 'Tepat',

		ta: 'சரியானது',

		es: 'Correcto',
	},
	thumbsDownLabel: {
		en: 'Thumbs down',

		hi: 'गलत',

		ar: 'خاطئ',

		'zh-Hans': '错误的',

		de: 'Unrecht',

		kn: 'ತಪ್ಪು',

		pt: 'Errada',

		ms: 'Salah',

		id: 'Keliru',

		ta: 'தவறு',

		es: 'Incorrecto',
	},
	poweredByLabel: {
		en: 'Powered By',
		hi: 'द्वारा संचालित',
		ar: 'مشغل بواسطة',
		'zh-Hans': '供电',
		de: 'Bereitgestellt von',
		kn: 'ಇವರ ಕೃಪೆ ಇಂದ',
		pt: 'Distribuído por',
		ms: 'Dikuasai oleh',
		id: 'Dipersembahkan oleh',
		ta: 'மூலம் இயக்கப்படுகிறது',
		es: 'Energizado por',
	},
	cancelUploadLabel: {
		en: 'cancel upload',
		hi: 'अपलोड रद्द करें',
		ar: 'إلغاء الرفع',
		'zh-Hans': '取消上传',
		de: 'Hochladen abbrechen',
		kn: 'ಅಪ್ಲೋಡ್ ರದ್ದುಗೊಳಿಸಿ',
		pt: 'cancelar upload',
		ms: 'batalkan muat naik',
		id: 'batalkan unggahan',
		ta: 'பதிவேற்றத்தை ரத்து செய்',
		es: 'cancelar carga',
	},
	mediaLabel: {
		en: 'media',
		hi: 'मीडिया',
		ar: 'وسائل الإعلام',
		'zh-Hans': '媒体',
		de: 'Medien',
		kn: 'ಮಾಧ್ಯಮ',
		pt: 'meios de comunicação',
		ms: 'media',
		id: 'media',
		ta: 'ஊடகம்',
		es: 'medios de comunicación',
	},
	imageLabel: {
		en: 'image',
		hi: 'छवि',
		ar: 'صورة',
		'zh-Hans': '图片',
		de: 'Bild',
		kn: 'ಚಿತ್ರ',
		pt: 'imagem',
		ms: 'imej',
		id: 'gambar',
		ta: 'படம்',
		es: 'imagen',
	},
	previousLabel: {
		en: 'Previous',
		hi: 'पहले का',
		ar: 'سابق',
		'zh-Hans': '以前的',
		de: 'Vorherige',
		kn: 'ಹಿಂದಿನ',
		pt: 'Anterior',
		ms: 'Sebelumnya',
		id: 'Sebelumnya',
		ta: 'முந்தைய',
		es: 'Anterior',
	},
	nextLabel: {
		en: 'Next',
		hi: 'अगला',
		ar: 'التالي',
		'zh-Hans': '下一个',
		de: 'Nächste',
		kn: 'ಮುಂದಿನ',
		pt: 'Próximo',
		ms: 'Seterusnya',
		id: 'Lanjut',
		ta: 'அடுத்தது',
		es: 'Próximo',
	},
	accordianLabel: {
		en: 'Accordian',
		hi: 'अकॉर्डियन',
		ar: 'أكورديان',
		'zh-Hans': '手风琴',
		de: 'Akkordeon',
		kn: 'ಅಕಾರ್ಡಿಯನ್',
		pt: 'acordeão',
		ms: 'akordian',
		id: 'akordian',
		ta: 'அகார்டியன்',
		es: 'acordeón',
	},
	cardLabel: {
		en: 'Card',
		hi: 'कार्ड',
		ar: 'بطاقة',
		'zh-Hans': '卡片',
		de: 'Karte',
		kn: 'ಕಾರ್ಡ್',
		pt: 'Cartão',
		ms: 'Kad',
		id: 'Kartu',
		ta: 'அட்டை',
		es: 'Tarjeta',
	},
	sorryIDidnTUnderstandYourMessageShouldHaveAtLeastOneAlphanumericCharacterInItLabel:
	{
		en: "Sorry, I didn't understand. Your message should have at least one alphanumeric character in it.",
		hi: 'क्षमा करें, मुझे समझ नहीं आया। आपके संदेश में कम से कम एक अक्षर या अंक होना चाहिए।',
		de: 'Entschuldigung, ich habe es nicht verstanden. Ihre Nachricht sollte mindestens ein alphanumerisches Zeichen enthalten.',
		ar: 'آسف لم أفهم. يجب أن تحتوي رسالتك على حرف أبجدي رقمي واحد على الأقل.',
		'zh-Hans': '对不起，我不明白。您的消息中应至少包含一个字母数字字符。',
		kn: 'ಕ್ಷಮಿಸಿ, ನನಗೆ ಅರ್ಥವಾಗಲಿಲ್ಲ. ನಿಮ್ಮ ಸಂದೇಶವು ಅದರಲ್ಲಿ ಕನಿಷ್ಠ ಒಂದು ಆಲ್ಫಾನ್ಯೂಮರಿಕ್ ಅಕ್ಷರವನ್ನು ಹೊಂದಿರಬೇಕು.',
		pt: 'Desculpe, não entendi. Sua mensagem deve ter pelo menos um caractere alfanumérico.',
		ms: 'Maaf, saya tidak faham. Mesej anda harus mempunyai sekurang-kurangnya satu aksara alfanumerik di dalamnya.',
		id: 'Maaf, saya tidak mengerti. Pesan Anda harus memiliki setidaknya satu karakter alfanumerik di dalamnya.',
		ta: 'மன்னிக்கவும், எனக்கு புரியவில்லை. உங்கள் செய்தியில் குறைந்தபட்சம் ஒரு எண்ணெழுத்து எழுத்து இருக்க வேண்டும்.',
		es: 'Lo siento, no entendí. Su mensaje debe tener al menos un carácter alfanumérico.',
	},
};
export enum ToasterIdentifier {
	None,

	Network,

	Other,
}
